import React, { useEffect, useState } from "react";
import { Select, Button, ConfigProvider, Alert } from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;
   
const CustomSelect = (props) => {
  const { label, options, onSelect, valueKey, nameKey,mode, error,selectedValues } = props;
  // console.log(options)
  console.log(selectedValues)

  const [selectedValue, setSelectedValue] = useState(selectedValues);

  useEffect(() => {
    // Reset the selected value when the options change
    setSelectedValue(selectedValues);
  }, [options,selectedValues]);

  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect; 

  
  return (
    <>
      <div className="flex items-center">
        <label className="pr-3 w-32 text-left ">{label}</label>
        
        <Select
        className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
          placeholder={`Select ${label}`}
          
          onChange={(value) => { 
            setSelectedValue(value); 
            onSelect(value);
          }}
          mode={mode}
          value={selectedValue}
          dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'} 
        >
          {options?.map((option,index) => (  
           
            <Option   key={index} value={option[valueKey]}>
              {option[nameKey]}
              {/* {console.log(option)} */}
            </Option>
          ))}
        </Select>
        {error && <Alert message={`Please select a ${label}`} type="error" />}
      </div>
    </>
  );
};

export default CustomSelect;




